import { useEffect, useState } from "react";
import { GetOrganizationMasterData } from "../Services/MasterDataService";

export const useOrganizations = () => {
    const [organizations, setOrganizations] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");

    useEffect(() => {
        const loadOrganizations = async () => {
            try {
                setLoading(true);
                const res = await GetOrganizationMasterData();
                if (res.status !== "success") {
                    throw new Error(res.message);
                }
                setOrganizations(res.organizations || []);
            } catch (error) {
                setError(error.message || "Failed to load organizations.")
            } finally {
                setLoading(false);
            }
        };
        loadOrganizations();
    }, [])

    return { organizations, loading, error};
};

